export class Runtime {
    static previousGamespeed = 1;
    static gameSpeed = 1;
    static valueChangeMultiplier: 1 | 0 = 1;
    static currentDraggingItems: any[] = [];


    static pauseGamespeed = () => {
        Runtime.previousGamespeed = Runtime.gameSpeed === 0 ? Runtime.previousGamespeed : Runtime.gameSpeed;
        Runtime.gameSpeed = 0;
    }

    static unpauseGamespeed = () => {
        Runtime.gameSpeed = Runtime.previousGamespeed;
    }

    static changeSpeed = (amount: number) => {
        Runtime.previousGamespeed = Runtime.gameSpeed;
        Runtime.gameSpeed = amount;
    }



}